import React, { useEffect, useState } from "react";
import { api, CAD } from "../lib/api";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";

export default function Reports() {
  const [data, setData] = useState(null);
  const [from, setFrom] = useState(""); const [to, setTo] = useState("");
  const load = async () => {
    const q = new URLSearchParams(); if (from) q.set("date_from", from); if (to) q.set("date_to", to);
    const r = await api.get(`/reports?${q}`); setData(r.data);
  };
  useEffect(() => { load(); }, [from, to]); // eslint-disable-line
  if (!data) return <div>Loading…</div>;

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div><h1 className="heading-font text-3xl font-bold text-slate-900">Reports</h1><p className="text-sm text-slate-500 mt-1">Pipeline analytics and finance breakdown.</p></div>
        <div className="flex gap-2 items-center bg-white p-2 rounded-lg border border-slate-200">
          <input type="date" data-testid="report-date-from" value={from} onChange={e=>setFrom(e.target.value)} className="h-9 px-2 rounded text-sm border border-slate-200" />
          <span className="text-slate-400 text-sm">to</span>
          <input type="date" data-testid="report-date-to" value={to} onChange={e=>setTo(e.target.value)} className="h-9 px-2 rounded text-sm border border-slate-200" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white p-4 rounded-xl border border-slate-200">
          <div className="text-xs uppercase text-slate-500">Offer Conversion Rate</div>
          <div className="heading-font text-4xl font-bold text-orange-600 mt-2">{data.offer_conversion_pct}%</div>
        </div>
        <div className="bg-white p-4 rounded-xl border border-slate-200">
          <div className="text-xs uppercase text-slate-500">Enrollment Conversion</div>
          <div className="heading-font text-4xl font-bold text-slate-900 mt-2">{data.enrollment_conversion_pct}%</div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ChartCard title="Applications by Partner" data={data.by_partner} />
        <ChartCard title="Applications by College" data={data.by_college} />
        <ChartCard title="Applications by BDM" data={data.by_bdm} />
        <ChartCard title="Applications by Admissions Officer" data={data.by_admissions} />
        <ChartCard title="Applications by Intake" data={data.by_intake} />
      </div>

      {data.finance && Object.keys(data.finance).length > 0 && (
        <div className="bg-white p-6 rounded-xl border border-slate-200">
          <h2 className="heading-font text-lg font-semibold mb-4">Finance</h2>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            {[["Outstanding Commissions", data.finance.outstanding_commissions],
              ["Commission Received", data.finance.commission_received],
              ["Partner Commissions Payable", data.finance.partner_commissions_payable],
              ["Partner Commissions Paid", data.finance.partner_commissions_paid],
              ["Company Net Commission", data.finance.company_net_commission]].map(([l,v])=>(
              <div key={l}><div className="text-xs uppercase text-slate-500">{l}</div><div className="heading-font text-lg font-bold mono">{CAD(v)}</div></div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function ChartCard({ title, data }) {
  return (
    <div className="bg-white p-4 rounded-xl border border-slate-200">
      <h3 className="heading-font font-semibold mb-3">{title}</h3>
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
          <XAxis dataKey="label" tick={{fontSize: 11}} interval={0} angle={-20} textAnchor="end" height={60}/>
          <YAxis tick={{fontSize: 11}} allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="count" fill="#EA580C" radius={[6,6,0,0]} />
        </BarChart>
      </ResponsiveContainer>
      {data.length === 0 && <div className="text-center text-slate-400 text-sm py-8">No data.</div>}
    </div>
  );
}
